import getInsertLinkViewState from './getInsertLinkViewState';
import InsertLinkViewState from '../store/schema/InsertLinkViewState';

export function getFileNamesString(linkIds: string[]): string {
    const fileNames: string[] = [];
    linkIds.forEach(function(linkId) {
        const viewState: InsertLinkViewState = getInsertLinkViewState(linkId);
        if (viewState) {
            fileNames.push(viewState.file.name);
        }
    });

    return fileNames.join(', ');
}
